import { useSelector } from 'react-redux';
import { NAMESPACE } from './constants';
export const usePlatformJourneys = () => {
    return useSelector((state) => state[NAMESPACE]);
};
//# sourceMappingURL=usePlatformJourneys.js.map